<template>
  <ValidationObserver ref="observer">
    <form ref="edit_user_form" @submit.prevent="updateUser">
      <md-card>
        <md-card-header class="md-card-header-icon">
          <div class="card-icon">
            <md-icon>perm_identity</md-icon>
          </div>
          <h4 class="title">
            Edit user
          </h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Name</span
              ><span style="color:red">*</span>
            </label>
            <div class="md-layout-item">
              <validation-provider rules="name" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <md-input v-model="name" />
                  <validation-error :errors="apiValidationErrors.name" />
                </md-field>
                <span>{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>

          <div class="md-layout">
            <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Email</span
              ><span style="color:red">*</span>
            </label>
            <div class="md-layout-item">
              <validation-provider name="email" rules="required|email" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <md-input v-model="email" />
                  <validation-error :errors="apiValidationErrors.email" />
                </md-field>
                <span>{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>

          <div class="md-layout">
            <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Roles</span
              ><span style="color:red">*</span>
            </label>
            <div class="md-layout-item">
              <validation-provider rules="useroles" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <md-select v-model="role_id" multiple>
                    <md-optgroup v-for="(val, index) in options_role" :key="val.value" :label="index">
                      <md-option
                        v-for="option in val"
                        :key="option.value"
                        :value="parseInt(option.id)"
                      >
                        {{ option.name }}
                      </md-option>
                    </md-optgroup>
                  </md-select>
                  <validation-error
                    :errors="apiValidationErrors.service_master_category_id"
                  />
                </md-field>
                <span>{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>

          <div class="md-layout">
            <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Eshed</span>
            </label>
            <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-select v-model="pool_id">
                    <md-option v-for="option in options_pool_list" :key="option.value" :value="option.id">
                      {{ option.pool_name }}
                    </md-option>
                  </md-select>
                </md-field>
            </div>
          </div>

          <div class="md-layout">
            <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">New Password</span
              ><span style="color:red">*</span>
            </label>
            <div class="md-layout-item">
              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <md-input v-model="password" type="password" />
                  <validation-error :errors="apiValidationErrors.password" />
                </md-field>
                <span>{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="md-layout">
            <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Confirm New Password</span
              ><span style="color:red">*</span>
            </label>
            <div class="md-layout-item">
              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <md-input v-model="password_confirmation" type="password" />
                  <validation-error
                    :errors="apiValidationErrors.password_confirmation"
                  />
                </md-field>
                <span>{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
        </md-card-content>

        <md-card-actions>
          <md-button @click="addConfirmation">
            Updated user
          </md-button>
          <md-button class="md-info" @click="backtoList">
            Go to List
          </md-button>
        </md-card-actions>
      </md-card>
    </form>
  </ValidationObserver>
</template>

<script>
import { ValidationError } from "@/components";
import { extend, validate, localize, ValidationObserver } from "vee-validate";
import formMixin from "@/mixins/form-mixin";
import { required , email } from "vee-validate/dist/rules";
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import Swal from "sweetalert2";

// validasi pesan error required field
extend("name", {
  ...required,
  message: "Name field is required",
});
// extend("email", {
//   ...required,
//   message: "Email field is required",
// });
// extend('password', {
//   ...required,
//   message: 'Password field is required'
// });
// extend('confirm', {
//   ...required,
//   message: 'Confirm Password field is required'
// });

  extend('email', email);

// Override the default message.
extend('required', {
  ...required,
  message: 'Email field is required'
});

extend("useroles", {
  ...required,
  message: "Use Role field is required",
});

Vue.use(VueSweetalert2);
export default {
  name: "edit-users-test",

  // props: {
  //   user: Object
  // },

  components: { ValidationError, ValidationObserver },

  mixins: [formMixin],

  data: () => ({
    name: null,
    email: null,
    role_id: [],
    password: null,
    password_confirmation: null,
    options_role: null,
    pool_id: null,
    options_pool_list: null
  }),

  created() {
    this.getUserData();
    this.getDataPool();
  },

  methods: {
    // ambil data
    async getUserData() {
      if (this.$route.params.userId) {
        console.log(this.$route.params.userId);
        await this.$store.dispatch("users/get", this.$route.params.userId);
        this.user = await this.$store.getters["users/user"];
        this.name = this.user.name;
        this.email = this.user.email;
        this.role_id = this.user.role_id;
        this.pool_id = this.user.pool?this.user.pool.id:null;
        console.log(this.role_id);
        await this.$store.dispatch("role/list");
        this.options_role = await this.$store.getters["role/list"];

      
        this.options_role = _.mapValues(_.groupBy(this.options_role, 'division_name'),
                          clist => clist.map(division => _.omit(division, 'division_name')));
      } else {
        // kembali ke list user management
        await this.$router.replace({ name: "List Users Management" });
      }
    },

    async getDataPool(){
        await this.$store.dispatch("workshop_pool/list")
        this.options_pool_list = await this.$store.getters["workshop_pool/list"];
        
     
    },

    // fungsi tombol direct ke list user management
    backtoList(id) {
      this.$router.replace({ name: "List Users Management" });
    },

    // validasi add data
    async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return;
      }
      Swal.fire({
        title: "Are you sure?",
        text: "The data will be saved!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Edit it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.updateUser();
        }
      });
    },

    // fungsi update data
    async updateUser() {
      if (this.$route.params.userId == null || !this.$route.params.userId) {
        await this.$store.dispatch(
          "alerts/error",
          "You are not allowed not change data of default users."
        );
        return;
      }

      const user = {
        id: this.user.id,
        type: "users",
        name: this.name,
        email: this.email,
        role_id: this.role_id,
        pool_id: this.pool_id,
        password: this.password,
        password_confirmation: this.password_confirmation,
      };

      try {
        // kirim data ke api
        await this.$store.dispatch("users/update", user);
        // panggil alert success
        await this.$store.dispatch(
          "alerts/success",
          "User data changed successfully."
        );
        // kembali ke list user management
        await this.$router.replace({ name: "List Users Management" });
        //this.$refs['password_form'].reset()
      } catch (e) {
        // panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
        this.setApiValidation(e.response.data.errors);
      }
    },
  },
};
</script>
